<script>
	import { getContext, onMount } from 'svelte'
	import DraggableComponent from '@Components/DraggableComponent.svelte'
	import { on } from 'svelte/events'
	import { getIconHtml } from '@Utils/Icons.js'
	let { visible = false } = $props()
	const { getEditorCanvas, isDev, getController } = getContext('editor')
	let controller = getController()
	let editorCanvas = getEditorCanvas()
	let loops = $state([])
	let selected = $state({})
	let disabled = $state({})
	let isDarkMode = $state(window.isDarkMode)
	let disableAddOverviewButton = $state(false);
	window.addEventListener('colorSchemeChanged', (e) => {
		isDarkMode = e.isDarkMode
	})
	function getLoops() {
		return editorCanvas.getCourseFrameFeatures().map((f) => {
			return {
				id: f.get('courseId'),
				name: f.get('displayName')
			}
		})
	}
	onMount(() => {
		loops = getLoops()

	})
	editorCanvas.on('featureAdded', function (feature) {
		if(feature.get('courseId')) {
			loops = getLoops()
		}
	})
	editorCanvas.on('featureRemoved', function (feature) {
		if(feature.get('courseId')) {
			loops = getLoops()
		}
	})
	editorCanvas.on('featureUpdated', function (feature) {
		if(feature.get('courseId')) {
			for(let i = 0; i < loops.length; i++) {
				if(loops[i].id === feature.get('courseId')) {
					loops[i].name = feature.get('displayName')
					break
				}
			}
		}
	})
	editorCanvas.on('currentToolChange', function (t, element) {
		if (t !== 'addCourseFrame') {
			selected = {}
			disableAddOverviewButton = false
		} else {
			disableAddOverviewButton = true
		}
	})
	editorCanvas.on('frameSelected', function (feature) {
		if (feature && feature.get('courseId')) {
			selected[feature.get('courseId')] = true
		} else {
			selected = {}
		}
	})
	function getTooltip(loop) {
		return ""
		// if (hasFrame[loop.id]) {
		// 	return 'Edit loop frame'
		// }
		// return 'Add frame to guide'
	}
	function click(loop) {
		const res = editorCanvas.getCourseFrameFeature(loop.id)
		selected[loop.id] = !selected[loop.id]
		if (res) {
			editorCanvas.focus(res);
			editorCanvas.selectFeature(res, true);
		} else {
			editorCanvas.activateTool('addCourseFrame', {
				courseId: loop.id,
				displayName: loop.name
			})
		}
	}
</script>

<DraggableComponent initialY="60" initialX="220" yAlignment="bottom" xAlignment="right" closable={true} bind:visible>
	<div class="flex text-sm flex-col text-left pt-0 select-none">
		<div class="text-left w-full font-bold p-2 pt-0 select-none">Overviews</div>
		<div class="flex flex-col bg-neutral-200 dark:bg-bigsteel-900/20 list">
			{#each loops as loop}
				<div class="flex flex-1 flex-row space-between pb-1 pt-1 pr-2 pl-2 items-center justify-center item">
					<div class="flex-1 text-sm ">{loop.name}</div>
					<button class="menu-btn p-1 max-h-9 items-center justify-center" tooltip={getTooltip(loop)} selected={selected[loop.id] === true} disabled={disabled[loop.id] === true} onclick={() => click(loop)}>
						{@html getIconHtml('EditFrame', 'dark:bg-white')}
					</button>
				</div>
			{/each}
		</div>
		<div class="flex gap-2 p-2">
			<button
				name="add"
				tooltip="Add new overview and connect to your current loops"
				class="btn btn-solid-blue btn-sm flex-1"
				disabled={disableAddOverviewButton}
				onclick={() => {
					editorCanvas.unfocus()
					editorCanvas.fitAllFrames()
					editorCanvas.activateTool('addCourseFrame')
				}}>Add overview</button
			>
		</div>
	</div>
</DraggableComponent>

<style lang="postcss">
	.list {
		width: 180px;
		max-height: calc(100vh - 400px);
		overflow-y: auto;
	}
	.list .item {
		border-bottom: 1px solid light-dark(rgba(0, 0, 0, 0.1),rgba(255, 255, 255, 0.1));
	}
	.list .item:last-child {
		border-bottom: none;
	}
</style>
